import React from 'react'

export const Linkedin = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.31912 18.4844V9.8403H5.4485V18.4844H8.31942H8.31912ZM6.88441 8.66029C7.88525 8.66029 8.50833 7.99652 8.50833 7.167C8.4896 6.31858 7.88525 5.67334 6.90344 5.67334C5.92097 5.67334 5.2793 6.31858 5.2793 7.16693C5.2793 7.99645 5.90216 8.66022 6.8656 8.66022H6.88419L6.88441 8.66029ZM9.90805 18.4844H12.7784V13.6577C12.7784 13.3997 12.7972 13.141 12.873 12.9567C13.0804 12.4403 13.5528 11.9058 14.3459 11.9058C15.3844 11.9058 15.8001 12.6984 15.8001 13.8605V18.4844H18.6704V13.5281C18.6704 10.8731 17.2544 9.63764 15.3658 9.63764C13.8174 9.63764 13.1374 10.5038 12.7596 11.0938H12.7787V9.8406H9.9082C9.94567 10.6515 9.90798 18.4847 9.90798 18.4847L9.90805 18.4844Z"
      fill="#8B9EBC"
    />
  </svg>
)
